import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { connect } from 'react-redux';

import withi18n from '~/utils/withI18n';
import { getCurrentProduct } from '~/actions/actionsSet/recharge';
import { getLabelWithDefaultStr } from '~/utils/i18n';

import FlexBox from '~/components/FlexBox';
import { STATUS } from '../constants';

type Props = {
  rechargeProcut: Object,
  i18n: Object,
  getCurrentProduct: Function,
  locale: String,
};

const mapStateToProps = ({ rechargeProcut }) => ({ rechargeProcut });

export default
@withi18n
@connect(mapStateToProps, { getCurrentProduct })
class Banner extends React.Component<Props> {
  state = {
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  };

  componentDidUpdate(preProps) {
    let { proceedStatus: preStatus } = preProps.rechargeProcut;
    const { proceedStatus: status } = this.props.rechargeProcut;
    if (preStatus !== status) {
      if (this.timer) clearInterval(this.timer);
      if (status !== STATUS.FINISHED) this.countDown();
    }
  }

  supplyNumber = number => {
    number = String(Math.abs(number));
    if (number.length === 1) return `0${number}`;
    return number;
  };

  translate = (key, defaultVal) =>
    getLabelWithDefaultStr(`exchange-recharge-${key}`, this.props.i18n, defaultVal);

  countDown = () => {
    this.timer = setInterval(() => {
      let { startTime, endTime, proceedStatus } = this.props.rechargeProcut;
      if (!startTime) return;
      const target = proceedStatus === STATUS.PENDING ? startTime : endTime;
      const timestamp = Date.now();
      if (timestamp > target) return this.props.getCurrentProduct();
      const days = this.supplyNumber(moment(target).diff(moment(timestamp), 'days'));
      const hours = this.supplyNumber(moment(target).diff(moment(timestamp), 'hours') % 24);
      const minutes = this.supplyNumber(moment(target).diff(moment(timestamp), 'minutes') % 60);
      const seconds = this.supplyNumber(moment(target).diff(moment(timestamp), 'seconds') % 60);
      this.setState({ days, hours, minutes, seconds });
    }, 1000);
  };

  render() {
    const { props, state } = this;
    const { rechargeProcut } = props;
    let { proceedStatus, noticeLink, name } = rechargeProcut;
    noticeLink = JSON.parse(noticeLink || '{}');
    noticeLink = noticeLink[props.locale] || noticeLink.en;

    return (
      <Wrapper>
        <div className="content">
          <div className="title">{this.translate('title').replace(/{Symbol}/i, name)}</div>
          <div className="desc">{this.translate('desc')}</div>
          <div className="startText">
            {proceedStatus === STATUS.PENDING
              ? this.translate('startText')
              : proceedStatus === STATUS.PROCESSING
              ? this.translate('willEnd')
              : this.translate('hasEnd')}
          </div>
          <TimeBox end={[STATUS.PENDING, STATUS.PROCESSING].includes(proceedStatus) ? false : true}>
            <div className="box">
              <div className="number">{state.days}</div>
              <div className="unit">{this.translate('days')}</div>
            </div>
            <div className="box">
              <div className="number">{state.hours}</div>
              <div className="unit">{this.translate('hours')}</div>
            </div>
            <div className="box">
              <div className="number">{state.minutes}</div>
              <div className="unit">{this.translate('minutes')}</div>
            </div>
            <div className="box">
              <div className="number">{state.seconds}</div>
              <div className="unit">{this.translate('seconds')}</div>
            </div>
          </TimeBox>
          <a
            href={noticeLink || '#rechargeRule'}
            target={noticeLink ? props.getTarget() : '_self'}
            className="link"
          >
            {`${this.translate('rules')} >`}
          </a>
        </div>
      </Wrapper>
    );
  }
}

const TimeBox = styled(FlexBox)`
  .number {
    color: ${({ end }) => (end ? 'rgba(255, 255, 255, 0.5)' : '#ffffff')};
  }
  .unit {
    color: ${({ end }) => (end ? 'rgba(255, 255, 255, 0.5)' : '#f0b90b')};
  }
`;

const Wrapper = styled.div`
  background: url(${require('../images/banner-bg.png')}) no-repeat center;
  background-size: cover;
  padding-bottom: 45px;
  > .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 40px 16px 0;
    > .title {
      color: white;
      text-align: center;
      font-weight: 300;
      font-size: 20px;
    }
    > .desc {
      font-size: 12px;
      margin: 16px 0 24px;
      text-align: center;
      color: #848e9c;
    }
    > .startText {
      color: #848e9c;
      opacity: 0.5;
      font-size: 14px;
      text-align: center;
    }
    .box {
      width: 50px;
      height: 60px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 3px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 8px 0 16px;
      > .number {
        font-size: 20px;
      }
      > .unit {
        font-size: 12px;
      }
      &:not(:last-child) {
        margin-right: 14px;
      }
    }
    > .link {
      color: #fff;
      text-decoration-line: underline;
      font-size: 14px;
      &:hover {
        color: #f0b90b;
      }
    }
  }
  @media (min-width: 768px) {
    padding-bottom: 60px;
    > .content {
      padding: 40px 56px 0;
      > .title {
        font-size: 28px;
        line-height: 36px;
      }
      > .desc {
        width: 436px;
        font-size: 16px;
        margin: 8px 0 16px;
      }
      > .startText {
        font-size: 18px;
      }
      .box {
        width: 80px;
        height: 100px;
        margin: 16px 0 24px;
        > .number {
          font-size: 36px;
        }
        > .unit {
          font-size: 14px;
        }
      }
    }
  }
  @media (min-width: 1260px) {
    padding-bottom: 120px;
    > .content {
      width: 1260px;
      padding: 40px 200px 0;
      position: relative;
      > .title {
        font-size: 48px;
        line-height: 62px;
      }
      > .desc {
        width: auto;
        margin: 16px 0 24px;
      }
      > .link {
        position: absolute;
        right: 200px;
        bottom: 22px;
      }
    }
  }
`;
